<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-textarea
      class="margin__t--6"
      v-model="model"
      :id="id"
      :v="validator"
      :placeholder="translate(placeholder)"
    />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject, toRefs } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedure, useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'
import { get as _get } from 'lodash'

const InputTextarea = defineAsyncComponent(() => import('&/atoms/InputTextarea'))

const props = defineProps({ block: { type: Object, required: true } })

const { block } = toRefs(props)

const procedure = inject('procedure')
const procedure_execution = inject('procedure_execution')
const external_validations = inject('external_validations')

const validations = computed(() => ({ ...block.value.validations, external: _get(external_validations.value, block.value.model, {}) }))

const { translate } = useI18n()
const { getFromProcedure } = useProcedure({ procedure })
const { label, placeholder, model, id, defaultValue } = useModule({ component: block, parent: procedure_execution, default_value: getFromProcedure({ key: block.value.default_value }) })
const { validator } = useProcedureBlockValidator({ validations, state: model })

if (!model.value && defaultValue.value) model.value = defaultValue.value
</script>
